export enum AlarmCentralCompany {
  INTELBRAS = 'INTELBRAS',
  JFL = 'JFL',
  VETTI = 'VETTI',
  PARADOX = 'PARADOX',
  ALERTAI = 'ALERTAI',
}
export enum PartitionPermissionsDetails {
  DISARM = 'DISARM',
  ARM = 'ARM',
  ARM_STAY = 'ARM_STAY',
  ARM_AWAY = 'ARM_AWAY',
  READY = 'READY',
}

export enum AlarmCentralEndpoint {
  ALARM_CENTRAL_VETTI_ENDPOINT = 'v1/alarmCentral/vetti',
  ALARM_CENTRAL_JFL_ENDPOINT = 'v1/alarmCentral/jfl',
  ALARM_CENTRAL_INTELBRAS_ISECNET_V1_ENDPOINT = 'ALARM_CENTRAL_INTELBRAS_ISECNET_V1_ENDPOINT',
  ALARM_CENTRAL_INTELBRAS_ISECNET_V2_ENDPOINT = 'v1/alarmCentral/intelbras/isecNetV2',
}

export enum AlarmCentralModels {
  AMT4010 = 'AMT4010',
  AMT2018EEG = 'AMT2018EEG',
  AMT1016NET = 'AMT1016NET',
  AMT2110 = 'AMT2110',
  AMT2118EG = 'AMT2118EG',
  ANM24NET = 'ANM24NET',
  AMT2018E3G = 'AMT2018E3G',
  AMT2018ESMART = 'AMT2018ESMART',
  ELC3020NET = 'ELC3020NET',
  AMT8000 = 'AMT8000',
  AMT8000PRO = 'AMT8000PRO',
  AMT8000LITE = 'AMT8000LITE',
  GPRS1000UN = 'GPRS1000UN',
  AMT1000SMART = 'AMT1000SMART',
  ACTIVE8ULTRA = 'ACTIVE8ULTRA',
  ACTIVE20BUS = 'ACTIVE20BUS',
  ACTIVE20ULTRA = 'ACTIVE20ULTRA',
  ACTIVE20ETHERNET = 'ACTIVE20ETHERNET',
  ACTIVE20GPRS = 'ACTIVE20GPRS',
  ACTIVE32DUO = 'ACTIVE32DUO',
  ACTIVE100BUS = 'ACTIVE100BUS',
  ACTIVEFULL32 = 'ACTIVEFULL32',
  ACTIVE20 = 'ACTIVE20',
  ACTIVE8W = 'ACTIVE8W',
  M300 = 'M300',
  M300FLEX = 'M300FLEX',
  SMARTALARMM = 'SMARTALARMM',
  SMARTALARMME = 'SMARTALARMME',
  SMARTALARMMONITORADA = 'SMARTALARMMONITORADA',
  EVO48 = 'EVO48',
  EVO192 = 'EVO192',
  EVOHD = 'EVOHD',
  MG5000 = 'MG5000',
  MG5050 = 'MG5050',
  ESPECTRA1728 = 'ESPECTRA1728',
  ESPECTRA1738 = 'ESPECTRA1738',
  ESPECTRA1832 = 'ESPECTRA1832',
  ESPECTRA1864 = 'ESPECTRA1864',
  SP4000 = 'SP4000',
  SP5500 = 'SP5500',
  SP6000 = 'SP6000',
  SP7000 = 'SP7000',
}

export enum AlarmCentralProblems {}
